/**
 * Add to Cart Modal – Dynamic.
 * Fetches product JSON, populates modal with options, handles add to cart.
 */
(function () {
  var modalId = 'addToCartModal';
  var baseUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (baseUrl && baseUrl.slice(-1) !== '/') baseUrl += '/';

  function getModal() {
    return document.getElementById(modalId);
  }

  function getShopCurrency() {
    var modal = getModal();
    if (modal && modal.dataset.shopCurrency) return modal.dataset.shopCurrency;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
    return 'USD';
  }

  function getShopLocale() {
    var modal = getModal();
    if (modal && modal.dataset.shopLocale) return modal.dataset.shopLocale;
    if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
    return (navigator.language || 'en-US');
  }

  function moneyFormat(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(getShopLocale(), {
        style: 'currency',
        currency: getShopCurrency()
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function refreshJudgemeBadge(badgeEl) {
    if (!badgeEl) return;
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
      return;
    }
    if (window.jdgm && typeof window.jdgm.loadHTML === 'function') {
      window.jdgm.loadHTML();
    }
  }

  function setModalJudgemeBadge(product, cardEl) {
    var modal = getModal();
    if (!modal || !product) return;
    var badgeEl = modal.querySelector('[data-modal-judgeme-badge]');
    if (!badgeEl) return;

    var cardBadge = cardEl && cardEl.querySelector('.bison-judgeme-badge');
    badgeEl.setAttribute('data-id', String(product.id));
    badgeEl.classList.add('jdgm-widget', 'jdgm-preview-badge', 'bison-judgeme-badge');

    if (cardBadge && cardBadge.innerHTML.trim() !== '') {
      badgeEl.innerHTML = cardBadge.innerHTML;
      return;
    }

    badgeEl.innerHTML = '';
    refreshJudgemeBadge(badgeEl);
  }

  function getSelectedVariant(product, selections) {
    if (!product.variants || !product.variants.length) return product.variants[0] || null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < (product.options || []).length; j++) {
        var optVal = (v['option' + (j + 1)] || '').toString();
        if (optVal !== (selections[j] || '').toString()) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return product.variants[0] || null;
  }

  function getOptionValues(product, optionIndex) {
    var opt = (product.options || [])[optionIndex];
    if (opt && opt.values && opt.values.length) return opt.values;
    var vals = {};
    (product.variants || []).forEach(function (v) {
      var vv = (v['option' + (optionIndex + 1)] || '').toString();
      if (vv) vals[vv] = true;
    });
    return Object.keys(vals);
  }

  function escapeAttr(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildOptionHtml(product, selections) {
    var html = '';
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var name = (typeof opt === 'string' ? opt : (opt && opt.name) || ('Option ' + (i + 1))).toString().toUpperCase();
      var values = getOptionValues(product, i);
      if (values.length === 0) continue;
      var isColor = /color|colour/i.test(name);
      html += '<div class="modal-option-group" data-option-index="' + i + '">';
      html += '<div class="section-heading">' + escapeAttr(name) + '</div>';
      html += '<div class="option-values">';
      for (var k = 0; k < values.length; k++) {
        var val = values[k];
        var valStr = (typeof val === 'string' ? val : (val || '').toString());
        var sel = (selections[i] || '').toString();
        var isSelected = sel === valStr;
        var valAttr = escapeAttr(valStr);
        if (isColor) {
          var swatchImg = '';
          var variantWithImg = product.variants.filter(function (v) {
            return (v['option' + (i + 1)] || '').toString() === valStr && v.featured_image && v.featured_image.src;
          })[0];
          if (variantWithImg && variantWithImg.featured_image) {
            swatchImg = '<img src="' + escapeAttr(variantWithImg.featured_image.src) + '" alt="" role="presentation">';
          } else {
            swatchImg = '<span style="display:block;width:100%;height:100%;background:#ddd;"></span>';
          }
          html += '<button type="button" class="color-swatch option-btn' + (isSelected ? ' selected' : '') + '" data-option-index="' + i + '" data-option-value="' + valAttr + '" title="' + valAttr + '">' + swatchImg + '</button>';
        } else {
          html += '<button type="button" class="option-btn' + (isSelected ? ' selected' : '') + '" data-option-index="' + i + '" data-option-value="' + valAttr + '">' + escapeAttr(valStr) + '</button>';
        }
      }
      html += '</div></div>';
    }
    return html;
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.add-to-cart-modal-bison__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    resetAddSuccess(modal);
    modal.classList.remove('is-closing');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function transitionToCartDrawer(modal) {
    if (!modal) return;
    resetAddSuccess(modal);
    modal.classList.add('is-closing');
    window.setTimeout(function () {
      modal.classList.remove('is-open', 'is-closing');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openCartDrawer();
    }, 260);
  }

  function resetAddSuccess(modal) {
    if (!modal) return;
    var success = modal.querySelector('[data-modal-success]');
    if (success) success.hidden = true;
    var addBtn = modal.querySelector('[data-modal-add-btn]');
    if (addBtn) addBtn.classList.remove('is-added');
  }

  function setAddButtonLabel(addBtn, label, disabled) {
    if (!addBtn) return;
    addBtn.disabled = !!disabled;
    addBtn.innerHTML = '<i class="fas fa-shopping-cart"></i> ' + label;
  }

  function showAddSuccess(modal) {
    if (!modal) return;
    var success = modal.querySelector('[data-modal-success]');
    if (success) success.hidden = false;
    var addBtn = modal.querySelector('[data-modal-add-btn]');
    if (addBtn) {
      addBtn.classList.add('is-added');
      addBtn.disabled = false;
      addBtn.innerHTML = '<i class="fas fa-check add-to-cart-modal-bison__btn-check"></i><span>ADD TO CART</span>';
    }
  }

  function updateCartBubble() {
    var bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (cartUrl.indexOf('.js') < 0) cartUrl = cartUrl.replace(/\/(cart)\/?$/i, '/$1.js');
    return fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bubbles.forEach(function (b) {
          b.textContent = cart.item_count;
          var w = b.closest('.cart-count-bubble');
          if (w) w.classList.toggle('hidden', cart.item_count < 1);
        });
        return cart;
      });
  }

  function openCartDrawer() {
    if (window.BisonStaticCartDrawer && typeof window.BisonStaticCartDrawer.open === 'function') {
      window.BisonStaticCartDrawer.open();
    }
  }

  function showLoading(show) {
    var modal = getModal();
    if (!modal) return;
    var loading = modal.querySelector('[data-modal-loading]');
    var content = modal.querySelector('[data-modal-content]');
    var footer = modal.querySelector('[data-modal-footer]');
    var success = modal.querySelector('[data-modal-success]');
    if (loading) loading.hidden = !show;
    if (content) content.hidden = show;
    if (footer) footer.hidden = show;
    if (success && show) success.hidden = true;
  }

  function getOptionName(product, optionIndex) {
    var opt = (product.options || [])[optionIndex];
    if (typeof opt === 'string') return opt;
    return (opt && opt.name) || '';
  }

function getPromoPercent(product) {
  if (!product || !product.tags) return 0;

  var tags = product.tags;

  // Shopify may return tags as an array or a comma-separated string.
  if (typeof tags === 'string') {
    tags = tags.split(',').map(function (tag) {
      return tag.trim();
    });
  }

  if (!Array.isArray(tags)) return 0;

  for (var i = 0; i < tags.length; i++) {
    var match = String(tags[i]).trim().match(/^promo-(\d+)-off$/i);

    if (match) {
      var percent = parseInt(match[1], 10);

      if (percent > 0 && percent < 100) {
        return percent;
      }
    }
  }

  return 0;
}

  function getCardSelectedVariantId(cardEl) {
    if (!cardEl) return '';
    var storedId = cardEl.getAttribute('data-selected-variant-id') || '';
    if (storedId) return String(storedId);
    var input = cardEl.querySelector('[data-card-variant-id]');
    if (input && input.value) return String(input.value);
    return '';
  }

  function getSelectionsFromCard(cardEl, product) {
    var opts = product.options || [];
    var selections = [];
    var i;
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;

    for (i = 0; i < opts.length; i++) {
      var fromVariant = variant ? (variant['option' + (i + 1)] || '').toString() : '';
      if (fromVariant) {
        selections[i] = fromVariant;
      } else {
        var values = getOptionValues(product, i);
        selections[i] = values[0] ? String(values[0]) : '';
      }
    }

    if (!cardEl) {
      return { selections: selections, variant: getSelectedVariant(product, selections) || variant };
    }

    var storedId = getCardSelectedVariantId(cardEl);
    if (storedId && product.variants) {
      for (var vi = 0; vi < product.variants.length; vi++) {
        if (String(product.variants[vi].id) === storedId) {
          variant = product.variants[vi];
          for (i = 0; i < opts.length; i++) {
            selections[i] = (variant['option' + (i + 1)] || '').toString();
          }
          return { selections: selections, variant: variant };
        }
      }
    }

    var colorPos = cardEl.getAttribute('data-color-option-position');
    var activeColor = cardEl.querySelector('[data-card-color-swatch].is-active:not(.is-unavailable)');

    for (i = 0; i < opts.length; i++) {
      var name = getOptionName(product, i);
      var pos = String(i + 1);

      if (/color|colour/i.test(name) || (colorPos && colorPos === pos)) {
        if (activeColor) {
          var colorVal =
            activeColor.getAttribute('data-color-value') ||
            activeColor.getAttribute('data-option-value') ||
            '';
          if (colorVal) selections[i] = colorVal;
        }
        continue;
      }

      var activeText =
        cardEl.querySelector(
          '[data-card-option][data-option-position="' + pos + '"].is-active:not(.is-unavailable)'
        ) ||
        cardEl.querySelector(
          '[data-card-pack-option][data-option-position="' + pos + '"].is-active:not(.is-unavailable)'
        );
      if (activeText) {
        var textVal = activeText.getAttribute('data-option-value') || '';
        if (textVal) selections[i] = textVal;
      }
    }

    return {
      selections: selections,
      variant: getSelectedVariant(product, selections) || variant
    };
  }

  function populateModal(product, cardEl) {
    var modal = getModal();
    if (!modal || !product) return;
    resetAddSuccess(modal);

    var fromCard = getSelectionsFromCard(cardEl, product);
    var selections = fromCard.selections;
    var variant = fromCard.variant;

    var img = variant && variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : (product.featured_image && product.featured_image.src ? product.featured_image.src : 'https://dummyimage.cloudtechsolution.co/533x533/cccccc/000000.png');
    var url = product.url || '/products/' + (product.handle || '');
    var price = variant ? variant.price : (product.price || 0);
var comparePrice = variant && variant.compare_at_price ? variant.compare_at_price : 0;
var discount = '';

var promoPercent = getPromoPercent(product);
console.log('BISON MODAL PRODUCT:', product);
console.log('BISON MODAL TAGS:', product.tags);
console.log('BISON PROMO PERCENT:', promoPercent);


if (promoPercent > 0) {
  comparePrice = price;
  price = Math.round(price * (100 - promoPercent) / 100);
  discount = '-' + promoPercent + '%';
} else if (comparePrice > price && comparePrice > 0) {
  var pct = Math.round(((comparePrice - price) / comparePrice) * 100);
  discount = '-' + pct + '%';
}

    modal.querySelector('[data-modal-image]').src = img;
    modal.querySelector('[data-modal-image]').alt = product.title || '';
    modal.querySelector('[data-modal-product-url]').href = url;
    modal.querySelector('[data-modal-title]').textContent = product.title || '';
    modal.querySelector('[data-modal-brand]').textContent = (product.vendor || '').toUpperCase();
    modal.querySelector('[data-modal-price]').textContent = moneyFormat(price);
    var compareEl = modal.querySelector('[data-modal-compare-price]');
    compareEl.textContent = comparePrice > 0 ? moneyFormat(comparePrice) : '';
    compareEl.hidden = !(comparePrice > price);
    var discountEl = modal.querySelector('[data-modal-discount]');
    discountEl.textContent = discount;
    discountEl.hidden = !discount;
    modal.querySelector('[data-modal-view-link]').href = url;

    setModalJudgemeBadge(product, cardEl);

    var optionsWrap = modal.querySelector('[data-modal-options]');
    optionsWrap.innerHTML = buildOptionHtml(product, selections);

    modal.querySelector('[data-qty-val]').textContent = '1';
    var addBtn = modal.querySelector('[data-modal-add-btn]');
    setAddButtonLabel(addBtn, variant && variant.available ? 'ADD TO CART' : 'SOLD OUT', !variant || !variant.available);
    var buyBtn = modal.querySelector('[data-modal-buy-btn]');
    buyBtn.href = url;
    buyBtn.style.display = variant && variant.available ? '' : 'none';

    modal.dataset.currentProduct = JSON.stringify(product);
    modal.dataset.currentSelections = JSON.stringify(selections);
    updateModalVariant(modal);
  }

  function updateModalVariant(modal) {
    var productJson = modal.dataset.currentProduct;
    if (!productJson) return;
    var product = JSON.parse(productJson);
    var selections = JSON.parse(modal.dataset.currentSelections || '[]');
    var variant = getSelectedVariant(product, selections);
    var imgEl = modal.querySelector('[data-modal-image]');
    if (imgEl && variant && variant.featured_image && variant.featured_image.src) {
      imgEl.src = variant.featured_image.src;
    } else if (imgEl && product.featured_image && product.featured_image.src) {
      imgEl.src = product.featured_image.src;
    }
    var price = variant ? variant.price : 0;
var comparePrice = variant && variant.compare_at_price ? variant.compare_at_price : 0;
var discount = '';

var promoPercent = getPromoPercent(product);

if (promoPercent > 0) {
  comparePrice = price;
  price = Math.round(price * (100 - promoPercent) / 100);
  discount = '-' + promoPercent + '%';
} else if (comparePrice > price && comparePrice > 0) {
  discount = '-' + Math.round(((comparePrice - price) / comparePrice) * 100) + '%';
}

modal.querySelector('[data-modal-price]').textContent = moneyFormat(price);

var compareEl = modal.querySelector('[data-modal-compare-price]');
compareEl.textContent = comparePrice > price ? moneyFormat(comparePrice) : '';
compareEl.hidden = !(comparePrice > price);
    var discountEl = modal.querySelector('[data-modal-discount]');
    discountEl.textContent = discount;
    discountEl.hidden = !discount;
    var addBtn = modal.querySelector('[data-modal-add-btn]');
    setAddButtonLabel(addBtn, variant && variant.available ? 'ADD TO CART' : 'SOLD OUT', !variant || !variant.available);
    var buyBtn = modal.querySelector('[data-modal-buy-btn]');
    buyBtn.style.display = variant && variant.available ? '' : 'none';
    modal.dataset.currentVariantId = variant ? variant.id : '';
    resetAddSuccess(modal);
  }

  function handleOptionClick(modal, optionIndex, optionValue) {
    resetAddSuccess(modal);
    var selections = JSON.parse(modal.dataset.currentSelections || '[]');
    selections[parseInt(optionIndex, 10)] = optionValue;
    modal.dataset.currentSelections = JSON.stringify(selections);
    var group = modal.querySelector('.modal-option-group[data-option-index="' + optionIndex + '"]');
    if (group) {
      group.querySelectorAll('[data-option-value]').forEach(function (btn) {
        btn.classList.toggle('selected', btn.getAttribute('data-option-value') === optionValue);
      });
    }
    updateModalVariant(modal);
  }

  function addToCart(variantId, qty, callback) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (typeof url !== 'string') url = '/cart/add';
    if (url.indexOf('.js') < 0) url = url.replace(/(\/cart\/add)\/?$/i, '$1.js');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: String(variantId), quantity: parseInt(qty, 10) || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'Add failed');
        if (callback) callback();
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (callback) callback(err);
      });
  }

  function bind() {
    var modal = getModal();
    if (!modal) return;

    var closeBtn = modal.querySelector('.add-to-cart-modal-bison__close');
    var backdrop = modal.querySelector('.add-to-cart-modal-bison__backdrop');
    if (closeBtn && !closeBtn.dataset.bisonModalBound) {
      closeBtn.dataset.bisonModalBound = '1';
      closeBtn.addEventListener('click', closeModal);
    }
    if (backdrop && !backdrop.dataset.bisonModalBound) {
      backdrop.dataset.bisonModalBound = '1';
      backdrop.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });

    document.body.addEventListener('click', function (e) {
      if (!modal || !modal.classList.contains('is-open')) {
        var addBtn = e.target.closest('[data-add-to-cart-modal]');
        if (addBtn && !addBtn.disabled) {
          var card = addBtn.closest('.grid-product-card');
          var handle = card && card.getAttribute('data-product-handle');
          if (handle) {
            e.preventDefault();
            e.stopPropagation();
            showLoading(true);
            resetAddSuccess(modal);
            openModal();
            fetch(baseUrl + 'products/' + handle + '.js', {
              method: 'GET',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            })
              .then(function (r) {
                if (!r.ok) throw new Error('Product not found');
                return r.json();
              })
              .then(function (product) {
                showLoading(false);
                populateModal(product, card);
              })
              .catch(function (err) {
                console.error(err);
                showLoading(false);
                var loadEl = modal.querySelector('[data-modal-loading]');
                if (loadEl) loadEl.innerHTML = '<p>Could not load product.</p>';
              });
          }
        }
        return;
      }

      var optBtn = e.target.closest('[data-option-index][data-option-value]');
      if (optBtn && modal.contains(optBtn)) {
        e.preventDefault();
        e.stopPropagation();
        var idx = optBtn.getAttribute('data-option-index');
        var val = optBtn.getAttribute('data-option-value');
        if (idx != null && val != null) handleOptionClick(modal, idx, val);
        return;
      }

      var qtyMinus = e.target.closest('#addToCartModal [data-qty-minus]');
      if (qtyMinus) {
        e.preventDefault();
        resetAddSuccess(modal);
        var span = modal.querySelector('[data-qty-val]');
        var n = Math.max(1, parseInt(span.textContent, 10) - 1);
        span.textContent = n;
        return;
      }
      var qtyPlus = e.target.closest('#addToCartModal [data-qty-plus]');
      if (qtyPlus) {
        e.preventDefault();
        resetAddSuccess(modal);
        var span = modal.querySelector('[data-qty-val]');
        var n = parseInt(span.textContent, 10) + 1;
        span.textContent = n;
        return;
      }

      var viewCartBtn = e.target.closest('#addToCartModal [data-modal-view-cart]');
      if (viewCartBtn) {
        e.preventDefault();
        transitionToCartDrawer(modal);
        return;
      }

      var addModalBtn = e.target.closest('#addToCartModal [data-modal-add-btn]');
      if (addModalBtn && !addModalBtn.disabled) {
        e.preventDefault();
        var vid = modal.dataset.currentVariantId;
        var qty = parseInt(modal.querySelector('[data-qty-val]').textContent, 10) || 1;
        if (!vid) return;
        addModalBtn.disabled = true;
        addModalBtn.classList.remove('is-added');
        addModalBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding…';
        addToCart(vid, qty, function (err) {
          if (err) {
            var variant = null;
            try {
              var product = JSON.parse(modal.dataset.currentProduct || '{}');
              var selections = JSON.parse(modal.dataset.currentSelections || '[]');
              variant = getSelectedVariant(product, selections);
            } catch (ignore) {}
            setAddButtonLabel(
              addModalBtn,
              variant && variant.available ? 'ADD TO CART' : 'SOLD OUT',
              !variant || !variant.available
            );
            return;
          }
          showAddSuccess(modal);
          updateCartBubble();
        });
      }

      var buyBtn = e.target.closest('#addToCartModal [data-modal-buy-btn]');
      if (buyBtn) {
        e.preventDefault();
        var vid = modal.dataset.currentVariantId;
        var qty = parseInt(modal.querySelector('[data-qty-val]').textContent, 10) || 1;
        if (vid) {
          buyBtn.style.pointerEvents = 'none';
          addToCart(vid, qty, function (err) {
            buyBtn.style.pointerEvents = '';
            if (!err) {
              var root = (window.shopUrl || '').replace(/\/$/, '') || '';
              window.location.href = root + '/checkout';
            }
          });
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);

  window.BisonAddToCartModal = { open: openModal, close: closeModal };
})();
